<template>
    <!-- TODO: 활동검색 유/무료 동작안함, 항목 기본값 제목으로 선택안됨 -->
    <div class="container">
        <div class="row mb-5">
            <div class="col-lg-8 mx-auto">
                <h3 class="font-weight-light text-center">활동 검색 </h3>
                <div class="bg-white rounded shadow">
                    <div class="input-group rounded-pill p-1">
                        <div class="btn-group btn-group-toggle col" data-toggle="buttons">
                            <label class="btn btn-outline-secondary" :class="{'active':activity.activityJoinCost == '', 'focus' : activity.activityJoinCost == ''}" v-on:click="activity.activityJoinCost=''">
                                <input type="radio" name="activityJoinCost" id="jb-radio-1" v-model="activity.activityJoinCost" checked value="" > 전체
                            </label>
                            <label class="btn btn-outline-success"  v-on:click="activity.activityJoinCost=':'">
                                <input type="radio" name="activityJoinCost" id="jb-radio-2" v-model="activity.activityJoinCost" value=":"> 무료
                            </label>
                            <label class="btn btn-outline-danger"  v-on:click="activity.activityJoinCost='>'">
                                <input type="radio" name="activityJoinCost" id="jb-radio-3" v-model="activity.activityJoinCost" value=">"> 유료
                            </label>
                        </div>
                    </div>
                    <br/>

                    <div class="input-group rounded-pill p-1">
                        <div class="btn-toolbar" role="toolbar" aria-label="Toolbar with button groups">
                            <div class="btn-group mr-2" role="group" aria-label="Third group">
                                <button type="button" class="btn btn-outline-secondary" :class="{'active':dateType == ''}" @click="makeDate('')">전체</button>
                            </div>
                            <div class="btn-group mr-2" role="group" aria-label="Third group">
                                <button type="button" class="btn btn-outline-warning" :class="{'active':dateType == 'today'}" @click="makeDate('today')">오늘</button>
                            </div>
                            <div class="btn-group mr-2" role="group" aria-label="Third group">
                                <button type="button" class="btn btn-outline-success" :class="{'active':dateType == 'week'}" @click="makeDate('week')">이번 주</button>
                            </div>
                            <div class="btn-group mr-2" role="group" aria-label="Third group">
                                <button type="button" class="btn btn-outline-primary" :class="{'active':dateType == 'month'}" @click="makeDate('month')">이번 달</button>
                            </div>
                            <div class="btn-group mr-2" role="group" aria-label="Third group">
                                <button type="button" class="btn btn-outline-danger" :class="{'active':dateType == 'year'}" @click="makeDate('year')">올해</button>
                            </div>
                        </div>
                        <div class="input-group-prepend">
                            <span class="input-group-text"> 날짜지정</span>
                        </div>
                        <datePicker name="activityEndDay" placeHolder="해당 일을 포함하는 활동" v-model="activity.activityDate" @dp-change="setAll()"
                                    :config="options"></datePicker>
                    </div>

                    <div class="input-group rounded-pill p-1">
                        <div class="input-group-prepend">
                            <span class="input-group-text"> 항목</span>
                        </div>
                        <select v-model="target" class="form-control">
                            <option value="title" selected="selected">제목</option>
                            <option value="activityTags">태그</option>
                            <option value="activityPlaceName">장소</option>
                            <option value="activityDetails">상세</option>
                            <option value="activityNotice">공지</option>
                        </select>
                        <div class="input-group-prepend">
                            <span class="input-group-text"> 분류</span>
                        </div>
                        <select v-model="activity.category" class="form-control">
                            <option value="">모두</option>
                            <option v-bind:key="c.name" v-bind:value="c.code" v-for="c in $root.$children[0].category">{{c.name}}
                            </option>
                        </select>
                    </div>

                    <div class="input-group rounded-pill p-1">
                        <div class="input-group-prepend">
                            <span class="input-group-text"> 나이</span>
                        </div>
                        <select v-model="activity.minJoinLimitByAge" class="form-control">
                            <option selected="selected" value="">최소</option>
                            <option v-for="i in 25" :value="i">{{i}}</option>
                        </select>
                        <select v-model="activity.maxJoinLimitByAge" class="form-control">
                            <option selected="selected" value="">최대</option>
                            <option v-if="i<76" v-for="i in 100" :value="101 - i">{{101-i}}</option>
                        </select>
                    </div>
                    <div class="input-group rounded-pill p-1">
                        <div class="input-group-prepend">
                            <span class="input-group-text"> 레벨</span>
                        </div>
                        <select v-model="activity.minJoinLimitByLevel" class="form-control">
                            <option selected="selected" value="">최소</option>
                            <option v-for="i in 10" :value="i">{{i}}</option>
                        </select>
                        <select v-model="activity.maxJoinLimitByLevel" class="form-control">
                            <option selected="selected" value="">최대</option>
                            <option v-for="i in 10" :value="11 - i">{{11 - i}}</option>
                        </select>
                    </div>

                    <div class="input-group mb-4 rounded-pill p-1">
                        <div class="input-group-prepend">
                            <span class="input-group-text"> 검색어</span>
                        </div>
                        <input type="search" v-model="value" placeholder="활동을 검색해 보세요. "
                               aria-describedby="button-addon3" class="form-control bg-none border-1" @keyup.enter="searchActivity()">

                        <div class="input-group-append">
                            <button type="button" class="btn btn-primary" v-on:click="searchActivity()">
                                검색
                            </button>
                        </div>
                    </div>

                </div>

            </div>

        </div>
      <ActivityList ref="activityList" :page="search.page" :size="search.size" :query="search.query"/>
    </div>
</template>

<script>
    /* eslint-disable */
    import ActivityList from '@/components/activity/ActivityList.vue';
import moment from 'moment';
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
import datePicker from 'vue-bootstrap-datetimepicker';

    export default {
        name: 'ActivitySearch',
        components: {
            ActivityList, datePicker
        },/*
        props: {
            page: String,
            size: String,
            target: String,
            value: String,
            query: String,
        },*/
        data() {
            return {
                options: {
                    format: 'YYYYMMDD',
                    useCurrent: true,
                    locale: 'ko'
                },
                search: {
                    page:"0",
                    size:"4",
                    query:"",
                },
                activity: {
                    category: '',
                    activityJoinCost: '',
                    minJoinLimitByLevel: '',
                    maxJoinLimitByLevel: '',
                    minJoinLimitByAge: '',
                    maxJoinLimitByAge: '',
                    activityDate: '',
                    activityStartDay: '',
                    activityEndDay: '',
/*
                    title : '',
                    activityTags: '',
                    activityPlaceName: '',
                    activityDetails: '',
                    activityNotice: '',*/
                },
                target:'title',
                value:'',
                dateType:''
            }

        },
        methods: {
            makeQuery() {
                let query = "";
                query += !!this.target ? `${this.target}:${this.value},` : ""
                query += !!this.activity.activityJoinCost ? `activityJoinCost${this.activity.activityJoinCost}0,` : ""
                query += !!this.activity.minJoinLimitByLevel ? `minJoinLimitByLevel>${this.activity.minJoinLimitByLevel-1},` : ""
                query += !!this.activity.maxJoinLimitByLevel ? `maxJoinLimitByLevel<${this.activity.maxJoinLimitByLevel},` : ""
                query += !!this.activity.minJoinLimitByAge ? `minJoinLimitByAge>${this.activity.minJoinLimitByAge-1},` : ""
                query += !!this.activity.maxJoinLimitByAge ? `maxJoinLimitByAge<${this.activity.maxJoinLimitByAge},` : ""
                
                if(!!this.activity.activityDate) {
                    this.activity.activityStartDay = moment(this.activity.activityDate).add(+1,'d').format('YYYYMMDD');
                    this.activity.activityEndDay = moment(this.activity.activityDate).add(-1,'d').format('YYYYMMDD');

                    query += !!this.activity.activityStartDay ? `activityStartDay<${this.activity.activityStartDay},` : ""
                    query += !!this.activity.activityEndDay ? `activityEndDay>${this.activity.activityEndDay},` : ""
                } else if(this.dateType == 'today') {
                    query += !!this.activity.activityStartDay ? `activityStartDay<${this.activity.activityStartDay},` : ""
                    query += !!this.activity.activityEndDay ? `activityEndDay>${this.activity.activityEndDay},` : ""
                } else {
                    query += !!this.activity.activityStartDay ? `activityStartDay>${this.activity.activityStartDay},` : ""
                    query += !!this.activity.activityEndDay ? `activityEndDay<${this.activity.activityEndDay},` : ""
                }

                query += !!this.activity.category ? `category:${this.activity.category},` : ""

                this.search.query = query.replace(/#/gi,'');
            },
            searchActivity() {
                this.makeQuery()
                //console.log(this.search.query)
                this.$refs.activityList.searchSubmit(this.search);
                //this.$router.push({ name: 'activitySearch', params: this.search})
            },
            makeDate(type) {
                this.activity.activityDate = '';

                //console.log(this.activity.activityDate )
                this.dateType = type;
                switch (type) {
                    case 'today':
                        this.activity.activityStartDay = moment().add(+1,'d').format('YYYYMMDD');
                        this.activity.activityEndDay = moment().add(-1,'d').format('YYYYMMDD');
                        break;
                    case 'week':
                        this.activity.activityStartDay = moment().weekday(0).format('YYYYMMDD');
                        this.activity.activityEndDay = moment().weekday(7).format('YYYYMMDD');
                        break;
                    case 'month':
                        this.activity.activityStartDay = moment().startOf('month').format('YYYYMMDD');
                        this.activity.activityEndDay = moment().endOf('month').format('YYYYMMDD');
                        break;
                    case 'year':
                        this.activity.activityStartDay = moment().startOf('year').format('YYYYMMDD');
                        this.activity.activityEndDay = moment().endOf('year').format('YYYYMMDD');
                        break;
                    default:
                        this.activity.activityStartDay ='';
                        this.activity.activityEndDay ='';
                        break;
                }
            },
            setAll() {
                if(this.activity.activityDate)
                    this.dateType = '';
            }
        },

        mounted() {
        },
        created() {
            this.search.page = !!this.$route.params.page ? this.$route.params.page : ''
            this.search.size = !!this.$route.params.size ? this.$route.params.size : ''
            this.search.query = !!this.$route.params.query ? this.$route.params.query : ''
            this.target = !!this.$route.params.target ? this.$route.params.target : this.target;
            this.value = !!this.$route.params.value ? this.$route.params.value : ''
            this.activity.category = !!this.$route.params.category ? this.$route.params.category : ''
            this.makeQuery()
        },
        watch : {
        }

    }
</script>
<style>
    .form-control:focus {
        box-shadow: none;
    }

    .form-control-underlined {
        border-width: 0;
        border-bottom-width: 1px;
        border-radius: 0;
        padding-left: 0;
    }

    .form-control::placeholder {
        font-size: 0.95rem;
        color: #aaa;
        font-style: italic;
    }

</style>